"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonCta = require("@mmc/common-cta");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _constructedForm2 = _interopRequireDefault(require("./constructed-form.props/constructed-form.defaultProps"));
var _constructedForm3 = _interopRequireDefault(require("./constructed-form.props/constructed-form.propTypes"));
/**
 * ## FormButton - component
 *
 * A button form element
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var FormButton = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(FormButton, _React$Component);
  function FormButton() {
    return _React$Component.apply(this, arguments) || this;
  }
  FormButton.resourceType = function resourceType() {
    return 'FormButton_1_0_0';
  };
  var _proto = FormButton.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
      formError = _this$props.formError,
      loading = _this$props.loading,
      disabled = _this$props.disabled,
      hasErrorOnRequiredField = _this$props.hasErrorOnRequiredField;
    return nextProps.formError.isError !== formError.isError || nextProps.loading !== loading || nextProps.disabled !== disabled || nextProps.hasErrorOnRequiredField !== hasErrorOnRequiredField;
  };
  _proto.setPriority = function setPriority(isCaNewsLetterSignUp, type) {
    return isCaNewsLetterSignUp ? "" + (type === 'submit' ? 'medium' : 'high') : "" + (type === 'submit' ? 'critical' : 'high');
  };
  _proto.render = function render() {
    var _clsx;
    var _this$props2 = this.props,
      formError = _this$props2.formError,
      theme = _this$props2.theme,
      _this$props2$loading = _this$props2.loading,
      loading = _this$props2$loading === void 0 ? false : _this$props2$loading,
      _this$props2$disabled = _this$props2.disabled,
      disabled = _this$props2$disabled === void 0 ? false : _this$props2$disabled,
      _this$props2$data = _this$props2.data,
      type = _this$props2$data.type,
      name = _this$props2$data.name,
      label = _this$props2$data.label,
      submitted = _this$props2.submitted,
      isFormValid = _this$props2.isFormValid,
      isCaNewsLetterSignUp = _this$props2.isCaNewsLetterSignUp,
      validationMessageLabel = _this$props2.validationMessageLabel,
      hasErrorOnRequiredField = _this$props2.hasErrorOnRequiredField,
      backgroundColour = _this$props2.backgroundColour;
    var priority = this.setPriority(isCaNewsLetterSignUp, type);
    var shouldRenderValidationMsg = hasErrorOnRequiredField && !submitted && !isFormValid;
    var setButtonTheme = isCaNewsLetterSignUp && backgroundColour === 'dark';
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_constructedForm["default"].formField, _constructedForm["default"].submitContainer, _constructedForm["default"].formWidth),
      key: name
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_constructedForm["default"].insideSubmitContainer, (_clsx = {}, _clsx[_constructedForm["default"].alignCenter] = isCaNewsLetterSignUp, _clsx))
    }, formError.isError && !isCaNewsLetterSignUp && /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
      message: formError.message,
      theme: theme,
      role: "alert"
    }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      data: {
        url: '',
        label: label,
        priority: "" + priority
      },
      classes: [_constructedForm["default"].formButton, _constructedForm["default"].loader, loading ? _constructedForm["default"].isLoading : '', setButtonTheme ? theme.dark : ''],
      disabled: isCaNewsLetterSignUp ? false : disabled
    }), shouldRenderValidationMsg && !isCaNewsLetterSignUp && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: _constructedForm["default"].errorMsg + " " + theme.smallType + " " + _constructedForm["default"].showMsg
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: _constructedForm["default"].errorIcon,
      src: "data:image/svg+xml,%3Csvg width='11' height='10' viewBox='0 0 11 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 9.5h11L5.5 0 0 9.5zM6 8H5V7h1v1zm0-2H5V4h1v2z' fill='%23ED0000' fill-rule='nonzero'/%3E%3C/svg%3E",
      alt: "errorIcon"
    }), validationMessageLabel))));
  };
  return FormButton;
}(_react["default"].Component);
exports["default"] = FormButton;
FormButton.displayName = 'FormButton';
FormButton.defaultProps = {
  data: _constructedForm2["default"].formComponents[8],
  // eslint-disable-line
  theme: {}
};